import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import authService from '../services/auth';
import { useAuth } from '../contexts/AuthContext';

const AuthCallback: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { refreshUser } = useAuth();

  useEffect(() => {
    const handleCallback = async () => {
      const queryParams = new URLSearchParams(location.search);
      const token = queryParams.get('token');

      if (token) {
        // 토큰 저장
        authService.setToken(token);
        
        // 사용자 정보 새로고침
        await refreshUser();
        
        // 메인 페이지로 리다이렉트
        navigate('/');
      } else {
        // 토큰이 없으면 로그인 페이지로
        navigate('/login');
      }
    };

    handleCallback();
  }, [location, navigate, refreshUser]);

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh' 
    }}>
      <div>
        <h2>로그인 처리 중...</h2>
        <p>잠시만 기다려주세요.</p>
      </div>
    </div>
  );
};

export default AuthCallback;